import NProgress from "nprogress";

export default class ProgressHelper {
    public static start() {
        NProgress.start();
    }

    public static done() {
        NProgress.done();
    }
}